import { useMemo, useState } from 'react';
import Image from 'next/image';

import Container from 'app/components/common/Container';

export default function DedicatedDevelopmentTeam({ section4 }) {
  const [hover, setHover] = useState(-1);

  const items = useMemo(() => {
    return section4?.team_section4detail?.map(
      ({ h, p, image, image_hover }, index) => ({
        icon: {
          src:
            hover === index
              ? image_hover?.data?.attributes?.url
              : (image?.data?.attributes?.url ?? '/'),
          alt: image?.data?.attributes?.alternativeText,
          width: image?.data?.attributes?.width,
          height: image?.data?.attributes?.height,
        },
        h,
        p,
      })
    );
  }, [hover, section4?.team_section4detail]);
  return (
    <div className="bg-dedicated-teams md:py-[55px] py-[30px]">
      <Container>
        <h3 className="text-center font-[800] xl:text-[50px] md:text-[32px] text-[26px] title_hd leading-tight max-w-[1000px] xl:mb-[34px] mb-[30px] mx-auto">
          {section4?.h1_black} {section4?.h1_purple} {section4?.h2_black}
        </h3>
        <div className="grid xl:grid-cols-4 lg:grid-cols-2 gap-6">
          {items?.map(({ h, p, icon }, index) => (
            <span
              onMouseOver={() => setHover(index)}
              onMouseLeave={() => setHover(-1)}
              className="block h-[100%] w-[100%] group"
              key={h}
            >
              <div
                className={`py-5 px-5 transition-all duration-200 ease-out transform rounded-lg h-full text-center bg-[#ffffff] group-hover:bg-primary`}
              >
                {icon.src && (
                  <div
                    className={`bg-primary text-white rounded-full md:p-4 p-3 w-fit mx-auto mb-3 group-hover:bg-[#FFF]`}
                  >
                    <Image
                      backendImgUrl={icon.src}
                      width={45}
                      height={45}
                      className="md:w-[45px] md:h-[45px] w-[35px] h-[35px]"
                      alt={icon.alt}
                      type="smallimg"
                    />
                  </div>
                )}
                <p className="text-[#303030] group-hover:text-[#FFFFFF] lg:text-[24px] text-[18px] font-[700] mb-2">
                  {h}
                </p>
                <p
                  className={
                    'text-[#303030] group-hover:text-[#FFFFFF] lg:text-[16px] md:text-[16px] text-[14px] font-[400] pb-2'
                  }
                >
                  {p}
                </p>
              </div>
            </span>
          ))}
        </div>
      </Container>
    </div>
  );
}
